import { csrfFetch } from 'javascripts/csrf_token';
import React from 'react';
import UserSelector from '../UserSelector/UserSelector';
import type { UserSelectorProps } from '../UserSelector/UserSelector';

type StudyResearchersProps = Omit<UserSelectorProps, 'onSelect' | 'onClear'> & {
  toggleUrl: string;
  clearUrl: string;
};

const StudyResearchers: React.FC<StudyResearchersProps> = ({
  toggleUrl,
  clearUrl,
  ...props
}) => {
  const selectCallback = (user_id: string, selected: boolean) => {
    return csrfFetch(toggleUrl, {
      method: 'PUT',
      body: JSON.stringify({
        toggle: selected ? '1' : '0',
        study_researcher: {
          user_id,
        },
      }),
    });
  };

  const clearCallback = () => {
    return csrfFetch(clearUrl, {
      method: 'DELETE',
    });
  };

  return (
    <UserSelector
      {...props}
      onSelect={selectCallback}
      onClear={clearCallback}
    />
  );
};

export default StudyResearchers;
